import * as Sentry from '@sentry/react';

const env = import.meta.env.REACT_APP_SENTRY_ENV || 'development';
const dsn = import.meta.env.REACT_APP_SENTRY_DSN;
const traceSampleRate = parseFloat(import.meta.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE || '0');

if (dsn) {
  Sentry.init({
    dsn,
    environment: env,
    tracesSampleRate: traceSampleRate,
    debug: env === 'development',
  });
}
